module.exports = __webpack_public_path__ + "static/media/gosave.7ec7f937.png";